/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { CreatePriceRowDto } from './CreatePriceRowDto';
import {
    CreatePriceRowDtoFromJSON,
    CreatePriceRowDtoFromJSONTyped,
    CreatePriceRowDtoToJSON,
    CreatePriceRowDtoToJSONTyped,
} from './CreatePriceRowDto';
import type { CreatePriceMode } from './CreatePriceMode';
import {
    CreatePriceModeFromJSON,
    CreatePriceModeFromJSONTyped,
    CreatePriceModeToJSON,
    CreatePriceModeToJSONTyped,
} from './CreatePriceMode';
import type { CreatePriceSessionQueryParametersDto } from './CreatePriceSessionQueryParametersDto';
import {
    CreatePriceSessionQueryParametersDtoFromJSON,
    CreatePriceSessionQueryParametersDtoFromJSONTyped,
    CreatePriceSessionQueryParametersDtoToJSON,
    CreatePriceSessionQueryParametersDtoToJSONTyped,
} from './CreatePriceSessionQueryParametersDto';

/**
 * 
 * @export
 * @interface CreatePriceSessionResponse
 */
export interface CreatePriceSessionResponse {
    /**
     * 
     * @type {CreatePriceMode}
     * @memberof CreatePriceSessionResponse
     */
    mode: CreatePriceMode;
    /**
     * 
     * @type {CreatePriceSessionQueryParametersDto}
     * @memberof CreatePriceSessionResponse
     */
    _queryParameters: CreatePriceSessionQueryParametersDto;
    /**
     * 
     * @type {Array<CreatePriceRowDto>}
     * @memberof CreatePriceSessionResponse
     */
    modifiedRows: Array<CreatePriceRowDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceSessionResponse
     */
    readonly modifiedRowsCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof CreatePriceSessionResponse
     */
    expiresAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreatePriceSessionResponse
     */
    createdAt: Date | null;
}



/**
 * Check if a given object implements the CreatePriceSessionResponse interface.
 */
export function instanceOfCreatePriceSessionResponse(value: object): value is CreatePriceSessionResponse {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('_queryParameters' in value) || value['_queryParameters'] === undefined) return false;
    if (!('modifiedRows' in value) || value['modifiedRows'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function CreatePriceSessionResponseFromJSON(json: any): CreatePriceSessionResponse {
    return CreatePriceSessionResponseFromJSONTyped(json, false);
}

export function CreatePriceSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePriceSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': CreatePriceModeFromJSON(json['mode']),
        '_queryParameters': CreatePriceSessionQueryParametersDtoFromJSON(json['queryParameters']),
        'modifiedRows': (json['modifiedRows'] == null ? null : (json['modifiedRows'] as Array<any>).map(CreatePriceRowDtoFromJSON)),
        'modifiedRowsCount': json['modifiedRowsCount'] == null ? undefined : json['modifiedRowsCount'],
        'expiresAt': (new Date(json['expiresAt'])),
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
    };
}

export function CreatePriceSessionResponseToJSON(json: any): CreatePriceSessionResponse {
    return CreatePriceSessionResponseToJSONTyped(json, false);
}

export function CreatePriceSessionResponseToJSONTyped(value?: Omit<CreatePriceSessionResponse, 'modifiedRowsCount'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': CreatePriceModeToJSON(value['mode']),
        'queryParameters': CreatePriceSessionQueryParametersDtoToJSON(value['_queryParameters']),
        'modifiedRows': (value['modifiedRows'] == null ? null : (value['modifiedRows'] as Array<any>).map(CreatePriceRowDtoToJSON)),
        'expiresAt': ((value['expiresAt']).toISOString()),
        'createdAt': (value['createdAt'] == null ? null : (value['createdAt'] as any).toISOString()),
    };
}

